import moment from 'moment';
import React, {useCallback, useMemo} from 'react';
import _ from 'lodash';
import {Table} from "react-bootstrap";
import Switch from "react-switch";
import PropTypes from "prop-types";
import {connect} from "react-redux";

const yearOptions = () => {
    const currentYear = moment().year();
    let startYear = 2019;
    let years = [{year: startYear, wanted: true}];

    while (startYear <= currentYear) {
        const year = startYear + 1;
        years.push({year, wanted: true})
        startYear++;
    };
    return years;
};


const UnwantedIHSYearsAdmin = ({membership,unwantedIHSYears, onChange}, context) => {

    const calculatedYearOptions = useMemo(() => {
        const options = yearOptions();
        _.each(options, (option) => {
            const found = _.find(unwantedIHSYears, (unwantedYear) => unwantedYear.year === option.year);
            if (found) {
                option.id = found.id;
                option.wanted = false;
            }
        })
        

        return options;
    }, [unwantedIHSYears]);

    const handleChange = useCallback((year)=>{
        //Borrar o agregar registro
        if(year.id){
            context.api.unwantedIHSYears.delete(year.id).then(onChange)
        }else{
            context.api.unwantedIHSYears.create(year).then(onChange)
        }

    },[onChange]);

    return (
        <div className="UnwantedIHSYearsAdmin">
            <h4>Anualidades IHS activas</h4>

            <Table>
                <tbody>
                {calculatedYearOptions.map((option ) => (
                    <tr key={option.year}>
                        <td>{option.year}</td>
                        <td>
                            <Switch
                                onChange={(value) => handleChange({
                                    id: option.id?option.id:null,
                                    year: option.year,
                                    wanted: value,
                                    membership: membership.id
                                })}
                                checked={option.wanted}/>
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>
        </div>
    );
};

//Context and Redux;
UnwantedIHSYearsAdmin.contextTypes = {
    api: PropTypes.object,
    notifier: PropTypes.object
};
const mapStateToProps = ({ api }) => {
    return {api};
};
export default connect(mapStateToProps)(UnwantedIHSYearsAdmin);



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/PersonDetail/components/UnwantedIHSYearsAdmin.jsx